export const resolveLocales = (locale?: string): string[] =>
  !locale || locale === 'en' ? ['en'] : [locale, 'en'];
